import { render, staticRenderFns } from "./CitizenNotification.vue?vue&type=template&id=2b222238&scoped=true"
import script from "./CitizenNotification.vue?vue&type=script&lang=js"
export * from "./CitizenNotification.vue?vue&type=script&lang=js"
import style0 from "./CitizenNotification.vue?vue&type=style&index=0&id=2b222238&prod&lang=scss&scoped=true"
import style1 from "./CitizenNotification.vue?vue&type=style&index=1&id=2b222238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b222238",
  null
  
)

export default component.exports